import { render } from "./CardComponent.vue?vue&type=template&id=f9a0f12c&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=f9a0f12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a0f12c"]])

export default __exports__